import { connect } from "react-redux";

import getPartsLoading from "../../selectors/getPartsLoading";
import getPartsPaginationPageInfo from "../../selectors/getPartsPaginationPageInfo";
import getPartsQuery from "../../selectors/getPartsQuery";
import getPartsWithPrice from "../../selectors/getPartsWithPrice";
import { AppState } from "../../store";
import { loadParts } from "../../store/parts/actions";
import Pagination from "./Pagination";

const mapState = (state: AppState) => {
  const { page, pages } = getPartsPaginationPageInfo(state);

  return {
    query: getPartsQuery(state),
    disabled: getPartsLoading(state),
    current: page,
    total: pages,
    parts: getPartsWithPrice(state),
  };
};

const mapActions = {
  loadParts,
};

export default connect(mapState, mapActions)(Pagination);
